import Popup from "../../common/Popup/Popup";
import TrainingLogTable from "./TrainingLogTable";

const TrainingLogPopup = ({ onClose }) => {
  return (
    <Popup
      title="Training Log Table"
      closeModal={onClose}
      width={{ width: "min(1400px, 96vw)", maxWidth: "96vw" }}
    >
      <TrainingLogTable />
    </Popup>
  );
};

export default TrainingLogPopup;
